<template lang="html">
    <page-material-study v-if="videoShareInfo" :user="user" :videoShareInfo="videoShareInfo" is-phone="isPhone" :tmId="tmId" :videoId="videoId">
    </page-material-study>
</template>

<script>
    import PageMaterialStudy from '@/components/Pages/PageMaterialStudy.vue';

    export default {
        props: {
            user: {
                type: Object,
                default: null,
            },
            isPhone: {
                type: String,
                default: null,
            },
            vsId: {
                type: String,
                default: null,
            },
        },
        components: {
            PageMaterialStudy
        },
        data: function () {
            return {
                videoShareInfo: null,
                tmId: null,
                videoId: null,
            };
        },
        methods: {
            decodeVideoShareInfo: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("VideoShare/DecodedVideoShareInfo", {
                        vsId: this.vsId,
                    });

                    let data = res.data;

                    if (data.success) {
                        let videoShareInfo = data.data;
                        this.tmId = videoShareInfo.TeachingMaterialId.toString();
                        this.videoId = videoShareInfo.VideoId;

                        this.videoShareInfo = data.data;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得教材分享資訊。發生不知名的錯誤");
                    loader.hide();
                }
            },
            initData: function () {
                this.decodeVideoShareInfo();
            },
        },
        computed: {
            
        },
        mounted: function () {
            this.initData();
        },
        watch: {
            
        },
        created() { },
    };
</script>
<style>
    
</style>